import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SignatureInfo } from '../model/signature';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SignatureService {
  constructor(private http: HttpClient) {}

  getInfo(hash: string): Observable<SignatureInfo> {
    return this.http.get<SignatureInfo>(`${environment.api}/forms/signatures/${hash}`);
  }

  saveSignature(hash: string, data: string): Observable<void> {
    return this.http.put<void>(`${environment.api}/forms/signatures/${hash}`, { data });
  }
}
